export default __webpack_public_path__ + "static/media/Apercu-Light.a6195b71.otf";